import { CurrencyCode } from "web_myplann/Shared/constants";
import { getCurrencyLocale } from "web_myplann/Shared/Utils/getCurrencyLocale";

export const formatCurrency = (
	value: number | null | undefined,
	currencyCode: CurrencyCode | string | null | undefined,
	decimalPlaces = 2,
) => {
	const formatter = new Intl.NumberFormat(getCurrencyLocale(currencyCode), {
		style: "currency",
		currency: currencyCode ?? CurrencyCode.CZK,
		maximumFractionDigits: decimalPlaces,
		minimumFractionDigits: 0,
	});
	return formatter.format(value ?? 0);
};

export const getCurrencySymbol = (currency?: CurrencyCode) => {
	if (currency) {
		return formatCurrency(0, currency).replace(/\d/g, "").trim();
	}

	return currency;
};
